import { useRef } from 'react'

// Gest "swipe left = wróć" na ekranach podglądu notatki (E3/E3b) — dotąd jedynym
// sposobem powrotu na E1 był przycisk/krzyżyk, a przypadkowy swipe w lewo (naturalny
// odruch na telefonie) wychodził poza aplikację (nawigacja wsteczna przeglądarki/PWA)
// zamiast cofać w obrębie aplikacji.
const SWIPE_THRESHOLD = 60
const AXIS_LOCK_THRESHOLD = 10

export function useSwipeBack(onSwipeLeft: () => void) {
  const startX = useRef<number | null>(null)
  const startY = useRef<number | null>(null)

  const onTouchStart = (e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX
    startY.current = e.touches[0].clientY
  }

  const onTouchEnd = (e: React.TouchEvent) => {
    if (startX.current === null || startY.current === null) return
    const dx = e.changedTouches[0].clientX - startX.current
    const dy = e.changedTouches[0].clientY - startY.current
    startX.current = null
    startY.current = null

    // Ignoruj ruchy głównie pionowe (scroll treści notatki) i te za krótkie.
    if (Math.abs(dy) > Math.abs(dx) + AXIS_LOCK_THRESHOLD) return
    if (dx >= -SWIPE_THRESHOLD) return

    onSwipeLeft()
  }

  return { onTouchStart, onTouchEnd }
}
